import React, { useState } from 'react';
import { Tooltip } from 'antd';

import { useAccess } from '../auth/AccessContext.jsx';
import BusinessDayDrawer from './BusinessDayDrawer.jsx';
import { useBusinessDay } from './BusinessDayContext.js';
import { chipOf } from './businessDay.js';

/**
 * The topbar's business day (IP-134; design 2026-10-06 section 8.1): the
 * oldest day that is not CLOSED and its stage - "6 Oct · Repricing" - with a
 * dot, white while the day is open for orders, gold while it is processed
 * (pulsing while Repricing or Day end runs; reviews pause during Repricing only, IP-171), green
 * once it closed. Its tooltip says "Reviews paused" during a pause, the open
 * dealing day, and any other day in progress. Under 640px only the dot and
 * the stage show.
 *
 * It sits on the dark topbar (#1f1a12), 12px/500 like the profile trigger,
 * and opens the "Business Day" drawer - reading the day again as it does.
 * Shown only to a person whose claims open the businessDay screen (any view
 * claim: @lfoc/domain/permissions.js), the claims GET /books/days checks.
 */
const BusinessDayChip = () => {
    const { canView } = useAccess();
    const { day: view, error, refresh } = useBusinessDay();
    const [open, setOpen] = useState(false);
    if (!canView('businessDay')) return null;

    const chip = chipOf(view, { error });
    const classes = ['console-day-chip', 'is-' + chip.tone, chip.running ? 'is-running' : '', chip.stale ? 'is-stale' : '']
        .filter(Boolean).join(' ');
    const openDrawer = () => {
        setOpen(true);
        refresh?.();
    };

    return (
        <>
            <Tooltip title={<div>{chip.tooltip.map((line) => <div key={line}>{line}</div>)}</div>} placement="bottom">
                <button type="button" className={classes} onClick={openDrawer} aria-label={chip.ariaLabel} aria-haspopup="dialog">
                    <span className="console-day-chip-dot" aria-hidden="true" />
                    {chip.date && <span className="console-day-chip-date">{chip.date}</span>}
                    {chip.date && <span className="console-day-chip-sep" aria-hidden="true">·</span>}
                    <span className="console-day-chip-stage">{chip.label}</span>
                </button>
            </Tooltip>
            <BusinessDayDrawer open={open} onClose={() => setOpen(false)} />
        </>
    );
};

export default BusinessDayChip;
